import { render, staticRenderFns } from "./QuestionFrame.vue?vue&type=template&id=4c68d23d&"
import script from "./QuestionFrame.vue?vue&type=script&lang=js&"
export * from "./QuestionFrame.vue?vue&type=script&lang=js&"
import style0 from "../styles/_question.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports